var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgC(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 16",
    focusable: "false"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 16,
    rx: 1.61,
    ry: 1.61,
    fill: "#d5d9dc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.12 9.81a3.55 3.55 0 01-1.18 2.53 4.22 4.22 0 01-2.82.92 3.77 3.77 0 01-3-1.29A5.27 5.27 0 0111 8.44v-.61a6.08 6.08 0 01.5-2.53A3.8 3.8 0 0113 3.62 4 4 0 0115.14 3a4 4 0 012.78 1 3.79 3.79 0 011.22 2.59h-2.06a2.08 2.08 0 00-.53-1.4 2 2 0 00-1.41-.43 1.74 1.74 0 00-1.53.73 4.13 4.13 0 00-.52 2.28v.75a4.45 4.45 0 00.48 2.36 1.72 1.72 0 001.55.75 2 2 0 001.41-.44 1.89 1.89 0 00.54-1.34z"
  }))));
}

export default __webpack_public_path__ + "ondemand/static/8b50f6e88/media/C.svg";
export { SvgC as ReactComponent };